import "core-js/es6/promise";
import "core-js/es6/string";
import "core-js/es7/array";

import Vue from "vue";
import Vuelidate from "vuelidate";
import router from "@/router";
import store from "@/store";
import i18n from "@/i18n";
import App from "@/app.vue";
// import "@/common/registerServiceWorker";

import VueResource from "vue-resource";
import BootstrapVue from "bootstrap-vue";
import VueSweetalert2 from "vue-sweetalert2";
import Snotify, { SnotifyPosition } from "vue-snotify";
import helpers from "@/plugins/helpers";
import datePicker from "vue-bootstrap-datetimepicker";
import timePicker from "vue-bootstrap-datetimepicker";
import VueClipboard from 'vue-clipboard2'
import DateRangePicker from 'vue2-daterange-picker';
import VueColumnsResizable from 'vue-columns-resizable';
import CKEditor from 'ckeditor4-vue';

const options = {
  toast: {
    position: SnotifyPosition.rightTop
  }
}

Vue.config.productionTip = process.env.NODE_ENV === "production" || false;

Vue.use(BootstrapVue);
Vue.use(Vuelidate);
Vue.use(VueResource);
Vue.use(VueSweetalert2);
Vue.use(Snotify, options);
Vue.use(datePicker);
Vue.use(timePicker);
Vue.use(DateRangePicker);
Vue.use(helpers, { $store: store, $router: router, $t: i18n, $swal: Vue.swal, $snotify: Vue });
Vue.use(VueClipboard);
Vue.use(VueColumnsResizable);
Vue.use(CKEditor);


import moment from "moment";
Object.defineProperty(Vue.prototype, "$moment", { value: moment });

// import "clusterize.js/clusterize.css";
// import clusterize from "clusterize.js";
// Object.defineProperty(Vue.prototype, '$clusterize', { value: clusterize });

/* eslint-disable no-new */
import $ from 'jquery';
import jQuery from 'jquery';
import config from "@/config";

export function resizeColumn1(){
  $(function() {
    var startX,
       startWidth,
       $handle,
       $table,
       pressed = false;

    $(document).on({
      mousemove: function(event) {
        if (pressed) {
          $handle.width(startWidth + (event.pageX - startX));
        }
      },
      mouseup: function() {
        if (pressed) {
          $table.removeClass('resizing');
          pressed = false;
        }
      }
    }).on('mousedown', '.table-resizable th', function(event) {
      $handle = $(this);
      pressed = true;
      startX = event.pageX;
      startWidth = $handle.width();

      $table = $handle.closest('.table-resizable').addClass('resizing');
    }).on('dblclick', '.table-resizable thead', function() {
      // Reset column sizes on double click
      $(this).find('th[style]').css('width', '');
    });
  });
}

$.extend(true, $.fn.datetimepicker.defaults, {
  icons: {
    time: 'far fa-clock',
    date: 'far fa-calendar',
    up: 'fas fa-arrow-up',
    down: 'fas fa-arrow-down',
    previous: 'fas fa-chevron-left',
    next: 'fas fa-chevron-right',
    today: 'fas fa-calendar-check',
    clear: 'far fa-trash-alt',
    close: 'far fa-times-circle'
  }
});

router.beforeEach((to, from, next) => {
  let query = to.fullPath.match(/^\/$/) ? {} : { redirect: to.fullPath };
  let path = "/denied";

  if (
    to.matched.some(record => {
      return record.meta.requiredLoggedIn && record.meta.includedPages;
    })
  ) {
    if (!store.getters.isLoggedIn) {
      next({ path: path, query: query });
      return;
    }

    let haveRole = false;
    let pages = to.matched[0].meta.subAccPage;
    let roles = store.getters.authorityRole;
    let superUser = config.superUser;
    let accountId = store.getters.account[0].account_id;

    //sub account here
    if(roles == "SUB_PRI") {
      if(to.path != "/account/subAccount") {
        let directPage = to.path.split("/").pop().toLowerCase();

        store.dispatch("user/getSubDetail")
        .then(response => {
        })
        .catch(response => {
        }); //get the latest authority option value from DB

        let access = store.getters.accountAuthority[0].authority_option;
        let exclude = ['log', 'report', 'system', 'minigame', 'matchteamlog', 'matchresultlog', 'setting','adjustmentlist','bonuslist','ticketwallettranslist'];

        if (exclude.includes(directPage))
          haveRole = true;
          else {
            if (access != null && access != '') {
              access =  access && access.length > 0 ? access.split(',') : []; // newly added
              // console.log(access, directPage, config.accessRoles[directPage])
              if (access.includes(config.accessRoles[directPage])) {
                if (superUser != accountId) {
                  if (!config.adminPages.includes(directPage))
                    haveRole = true;
                  else
                    haveRole = false;
                }
                else {
                    haveRole = true;
                }
              } else {
                haveRole = false;
              }
            } else
              haveRole = false;
          }
      }
    } else {
      let superUser = config.superUser;
      let accountId = store.getters.account[0].account_id;
      let directPage = to.path.split("/").pop().toLowerCase();
      if (superUser != accountId) {
        if (!config.adminPages.includes(directPage))
          haveRole = true;
        else
          haveRole = false;
      }
      else {
          haveRole = true;
      }
    }

    if (haveRole == false) {
      next({ path: path, query: query });
      return;
    }
  }

  next();
});

i18n.locale = store.state.layout.language;
// i18n.locale = "zh";

export const app = new Vue({
  router,
  store,
  i18n,
  mounted() {
    // console.log("ready");
  },
  render: h => h(App)
}).$mount("#app");
